import React from "react";
import { Offcanvas } from "react-bootstrap";
import ProfileCard from "./ProfileCard";
import Sidebar from "./Sidebar";

const OffCanvasSidebar = ({ showSidebar, handleCloseSidebar }) => {
  return (
    <Offcanvas
      id="offcanvasNavbar"
      show={showSidebar}
      onHide={handleCloseSidebar}
      placement="start"
      className="d-lg-none off-canvas-sidebar"
    >
      <Offcanvas.Header closeButton className="ps-2">
        <ProfileCard light={false} />
      </Offcanvas.Header>
      <Sidebar handleCloseSidebar={handleCloseSidebar} expandable={false} />
    </Offcanvas>
  );
};

export default OffCanvasSidebar;
